import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';

import { message } from 'antd';

import history from './history';
import { api } from './http/API';
import ContentWrapper from './pages/ContentWrapper';
import LegalAcceptModal from './pages/components/LegalAcceptModal';
import LoginPage from './pages/login/LoginPage';
import ForgotPasswordPage from './pages/login/ForgotPasswordPage';
import ResetPasswordPage from './pages/login/ResetPasswordPage';
import RegisterPage from './pages/login/RegisterPage';
import RegisterVerifyPage from './pages/login/RegisterVerifyPage';
import { saveCompany } from './storage/CompanyStorage';
import { saveUser } from './storage/UserStorage';
import { saveZonds } from './storage/ZondsStorage';
import PaymentSuccess from './pages/payment/PaymentSuccess';

import moment from 'moment';
import 'moment/locale/ru';

moment.locale('ru');

function App() {
    const dispatch = useDispatch();
    const [legalPending, setLegalPending] = useState<string[]>([]);

    useEffect(() => {
        // Публичные страницы, доступные без авторизации.
        const publicPaths = ['/login', '/register', '/forgot-password', '/reset-password', '/logout', '/payment/success'];
        const isPublic = publicPaths.some((p) => window.location.pathname.startsWith(p));

        if (localStorage.getItem('token') !== null) {
            api.GetUser()
                .then((res: any) => {
                    dispatch(saveUser(res));
                    // D4.18: модалка с документами, если есть pending.
                    if (res && Array.isArray(res.legal_pending) && res.legal_pending.length > 0) {
                        setLegalPending(res.legal_pending);
                    }
                    // D4.12: неподтверждённый email → на страницу верификации.
                    if (res && !res.email_verified_at && !isPublic) {
                        history.push(
                            '/register/verify?email=' + encodeURIComponent(res.email || ''),
                        );
                    }
                })
                .catch((_) => {
                    localStorage.removeItem('token');
                    history.push('/login');
                });

            api.GetCompany()
                .then((res) => dispatch(saveCompany(res)))
                .catch((err: any) => {
                    // legal_consent_required — это не потеря токена, оставляем на месте.
                    if (err?.response?.data?.error === 'legal_consent_required') return;
                    localStorage.removeItem('token');
                    history.push('/login');
                });
            api.GetZonds()
                .then((res) => dispatch(saveZonds(res)))
                .catch((err: any) => {
                    if (err?.response?.data?.error === 'legal_consent_required') return;
                    localStorage.removeItem('token');
                    history.push('/login');
                });
        } else if (!isPublic) {
            history.push('/login');
        }
    }, [dispatch]);

    return (
        <>
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/register/verify" element={<RegisterVerifyPage />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/admin" element={<AdminRedirect />} />
            <Route path="/grafana" element={<GrafanaRedirect />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="*" element={<ContentWrapper />} />
        </Routes>
        <LegalAcceptModal
            open={
                legalPending.length > 0 &&
                !['/login', '/register', '/forgot-password', '/reset-password', '/logout', '/payment/success'].some(
                    (p) => window.location.pathname.startsWith(p),
                )
            }
            pending={legalPending}
            onAccepted={() => {
                setLegalPending([]);
                window.location.reload();
            }}
        />
        </>
    );
}

function Logout() {
    localStorage.removeItem('token');
    return <Navigate to="/login" replace />;
}

function AdminRedirect() {
    window.open('https://admin.agropogoda.com', '_blank');
    return <Navigate to="/" replace />;
}

function GrafanaRedirect() {
    window.open('https://grafana.agropogoda.com', '_blank');
    return <Navigate to="/" replace />;
}

export default App;
